import axios from '@axios'

export default {
  namespaced: true,
  state: {
    respData: null,
  },
  getters: {
  },
  mutations: {
    GET_CONFIG_APPLICATION(state, payload) {
      state.respData = payload
      console.log(payload)
    },
    SWITCH_CHANGE(state, item) {
      const nameChild = item.name.split('.')
      console.log(nameChild)
      if (nameChild.length > 5) {
        state.respData[nameChild[0]][nameChild[1]][nameChild[2]][nameChild[3]][nameChild[4]][nameChild[5]] = item.status
      } else if (nameChild.length > 4) {
        state.respData[nameChild[0]][nameChild[1]][nameChild[2]][nameChild[3]][nameChild[4]] = item.status
      } else if (nameChild.length > 3) {
        state.respData[nameChild[0]][nameChild[1]][nameChild[2]][nameChild[3]] = item.status
      } else if (nameChild.length > 2) {
        state.respData[nameChild[0]][nameChild[1]][nameChild[2]] = item.status
      } else if (nameChild.length > 1) {
        state.respData[nameChild[0]][nameChild[1]] = item.status
      } else {
        state.respData[item.name] = item.status
      }
    },
    INPUT_CHANGE(state, item) {
      const nameChild = item.name.split('.')
      console.log(nameChild)
      if (nameChild.length > 5) {
        state.respData[nameChild[0]][nameChild[1]][nameChild[2]][nameChild[3]][nameChild[4]][nameChild[5]] = item.value
      } else if (nameChild.length > 4) {
        state.respData[nameChild[0]][nameChild[1]][nameChild[2]][nameChild[3]][nameChild[4]] = item.value
      } else if (nameChild.length > 3) {
        state.respData[nameChild[0]][nameChild[1]][nameChild[2]][nameChild[3]] = item.value
      } else if (nameChild.length > 2) {
        state.respData[nameChild[0]][nameChild[1]][nameChild[2]] = item.value
      } else if (nameChild.length > 1) {
        state.respData[nameChild[0]][nameChild[1]] = item.value
      } else {
        state.respData[item.name] = item.value
      }
    },
    UPDATE(state, payload) {
      state.respData = payload
      console.log(payload)
    },
  },
  actions: {
    get({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/web/application/hero/system/get')
          .then(response => {
            console.log(response)
            commit('GET_CONFIG_APPLICATION', response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    inputChange({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios
          .put('/api/web/application/hero/system/inputChange', item)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    switchChange({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios
          .put('/api/web/application/hero/system/switchChange', item)
          .then(response => {
            commit('SWITCH_CHANGE', item)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}
